export default "__VITE_ASSET__f57cdbbe__"